import { Button, Input, message, Modal, Radio, Upload } from "antd";
import React, { useCallback, useEffect, useState } from "react";

import PredeterminationDetails from "./PredeterminationDetails";

// import { useGetPatientInsuranceEligibility } from "../useGetPatientInsuranceEligibility";
// import PatientPolicyInfoFormModal from "../PatientPolicyInfoFormModal";
// import Eligibility2FAFormModal from "../Eligibility2FAFormModal";

import upload from "../../../../assets/icons/export.svg";
import { controller } from "../../../../controller";
import { describeApiError } from "../../lib/apiError";

export default function PredeterminationModal({
  setPredeterminationTreatmentID,
  setShowPredeterminationModal,
  predeterminationTreatmentID,
  showPredeterminationModal,
  predeterminationBatchID,
  eligibilityData,
  agentType,
  patient,
  // Optional: scope the upload to a specific patient + policy so the created
  // cases are linked (and appear in the insurance modal's per-(patient,policy)
  // list). The Estimates tab no longer opens this modal — what the FTC got back
  // on a requested estimate is recorded per submission there — so this is only
  // reached from the treatment-plan flows.
  patientId,
  policyId,
}) {
  const [switchToPredeterminationDetails, setSwitchToPredeterminationDetails] = useState(false);
  // const [showPatientInsuranceFormModal, setShowPatientInsuranceFormModal] = useState(false);
  // const [showEligibility2FAFormModal, setShowEligibility2FAFormModal] = useState(false);
  // const [editPatientInsuranceData, setEditPatientInsuranceData] = useState(false);
  // const [cancelProcess, setCancelProcess] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [files, setFiles] = useState([]);
  const [title, setTitle] = useState("");
  const [predeterminationAndPostPaymentState, setPredeterminationAndPostPaymentState] = useState("predetermination");
  const [predeterminationName, setPredeterminationName] = useState(undefined);
  const [insuranceID, setInsuranceID] = useState(null);

  // const {
  //   checkPatientInsuranceEligibility,
  //   isLoading: isAgentGettingPredeterminatonData,
  //   eligibilityData: predeterminationData,
  //   eligibilityAgentToken,
  //   predeterminationBatchID,
  // } = useGetPatientInsuranceEligibility(
  //   patient && patient.id,
  //   setShowPatientInsuranceFormModal,
  //   setShowEligibility2FAFormModal,
  //   "predetermination",
  //   cancelProcess
  // );

  const radioOptions = [
    { label: "Auto Extract", value: "predetermination" },
    { label: "Post Payment", value: "post_payment" },
    { label: "Simple Upload", value: "simple" },
  ];

  // useEffect(
  //   function () {
  //     if (predeterminationData !== undefined) {
  //       setSwitchToPredeterminationDetails(true);
  //     }
  //   },
  //   [predeterminationData]
  // );

  useEffect(
    function () {
      console.log(agentType, eligibilityData);
      if (agentType === "predetermination" && eligibilityData !== undefined) setSwitchToPredeterminationDetails(true);
    },
    [eligibilityData]
  );

  const handleSendRequest = async () => {
    const hasFiles = !!(files && files.length > 0);
    if (!hasFiles) {
      message.error("Attach a file first.");
      return;
    }

    // Map the radio selection to the backend mode.
    // "predetermination" => auto_extract (run AI agent), "post_payment", "simple" (file only).
    const mode = predeterminationAndPostPaymentState === "post_payment"
      ? "post_payment"
      : predeterminationAndPostPaymentState === "simple"
        ? "simple"
        : "auto_extract";

    const formData = new FormData();
    formData.append("name", title);
    formData.append("insurance_treatment_estimate", mode === "auto_extract" ? true : false);
    formData.append("mode", mode);
    if (patientId) formData.append("patient_id", patientId);
    if (policyId) formData.append("policy_id", policyId);
    files && files.length > 0 && files.map((file) => formData.append("files", file.originFileObj));
    formData.append("office", localStorage.getItem("selectedOffice"));

    try {
      setIsUploading(true);
      const response = await controller.uploadNewInsurnaces(formData);

      if (response.status < 250) {
        setFiles([]);
        setTitle("");
        if (mode === "simple") {
          // Nothing to process or review — just close; the parent reloads its list.
          message.success("File uploaded.");
          setShowPredeterminationModal(false);
        } else {
          message.success("Request sent successfully!");
          setInsuranceID(response.json.file_batch_id);
          setSwitchToPredeterminationDetails(true);
        }
      } else {
        // uploadNewInsurnaces resolves on 4xx/5xx rather than throwing, so the
        // catch below never ran for a server rejection — the button simply did
        // nothing. Every refusal here is actionable ("Patient not found.",
        // "office is required.", a permission failure), so show it.
        message.error(describeApiError(response, "Couldn't save that."));
      }
    } catch (err) {
      message.error("Something went wrong while uploading files.");
      console.error(err);
    }

    setIsUploading(false);
  };

  const handleUploadFiles = useCallback((e) => {
    const uploadedFiles = e.fileList;

    // Filter out duplicates based on file name and other unique properties
    const uniqueFiles = uploadedFiles.filter(
      (newFile, index, self) => index === self.findIndex((f) => f.name === newFile.name && f.size === newFile.size)
    );

    // Update state with unique files
    setFiles(uniqueFiles);
  }, []);

  function handleCloseModal() {
    if (isApproved) {
      setSwitchToPredeterminationDetails(false);
      setIsApproved(false);
    }

    setShowPredeterminationModal(false);
  }

  return (
    <Modal
      title={
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          {switchToPredeterminationDetails ? (predeterminationName ? `${predeterminationName}'s Details` : "") : "New Request"}

          <div style={{ display: "flex", alignItems: "center", marginLeft: "auto", gap: 10 }}>
            {/* <Button
              type="primary"
              onClick={() => {
                setCancelProcess(false);
                checkPatientInsuranceEligibility();
              }}
              loading={isAgentGettingPredeterminatonData}
            >
              Fetch by Agent
            </Button> */}

            <Button
              onClick={() => {
                setShowPredeterminationModal(false);
                if (predeterminationTreatmentID) {
                  setPredeterminationTreatmentID(undefined);
                }
              }}
              style={{ display: "flex", alignItems: "center", gap: 5, border: "2px solid #6b43b5", color: "#6b43b5", fontSize: 12 }}
            >
              Close
            </Button>
          </div>
        </div>
      }
      open={showPredeterminationModal}
      onCancel={handleCloseModal}
      style={{ padding: 10 }}
      width={switchToPredeterminationDetails ? "75%" : 600}
      height={switchToPredeterminationDetails ? "80%" : undefined}
      footer={null}
      closeIcon={null}
    >
      {switchToPredeterminationDetails ? (
        <PredeterminationDetails
          setSwitchToPredeterminationDetails={setSwitchToPredeterminationDetails}
          predeterminationOrPostPayment={predeterminationAndPostPaymentState}
          setPredeterminationTreatmentID={setPredeterminationTreatmentID}
          setShowPredeterminationModal={setShowPredeterminationModal}
          predeterminationTreatmentID={predeterminationTreatmentID}
          setPredeterminationName={setPredeterminationName}
          predeterminationBatchID={predeterminationBatchID}
          // predeterminationData={predeterminationData}
          eligibilityData={eligibilityData}
          setIsApproved={setIsApproved}
          insuranceID={insuranceID}
          isApproved={isApproved}
          patient={patient}
        />
      ) : (
        <>
          <p style={{ color: "#848696" }}>
            Please upload the files that need to be sent for further review. Once uploaded, the files will be processed and sent to the insurance company for evaluation.
          </p>

          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <p>Request Type</p>

            <Radio.Group
              value={predeterminationAndPostPaymentState}
              options={radioOptions}
              // disabled={isUploading || isAgentGettingPredeterminatonData}
              disabled={isUploading}
              onChange={(e) => setPredeterminationAndPostPaymentState(e.target.value)}
              style={{ display: "flex", alignItems: "center", gap: 20 }}
            />
          </div>

          <div style={{ marginTop: 30 }}>
            <p>Request File</p>

            <Upload.Dragger
              name="file"
              multiple={true}
              fileList={files}
              beforeUpload={() => false}
              onChange={handleUploadFiles}
              // disabled={isUploading || isAgentGettingPredeterminatonData}
              disabled={isUploading}
              style={{ backgroundColor: "#ffffff", padding: "30px 10px" }}
            >
              <p className="ant-upload-drag-icon">
                <img src={upload} alt="upload" />
              </p>
              <p className="ant-upload-hint">
                Darg and drop or <span style={{ color: "#6b43b5", fontSize: 18 }}>Browse</span> your files
              </p>
            </Upload.Dragger>
          </div>

          <div style={{ marginTop: 30, marginBottom: 20 }}>
            <p>Request Title</p>

            <Input
              value={title}
              disabled={isUploading}
              onChange={(e) => setTitle(e.target.value || "")}
              placeholder="Enter Title"
              style={{ width: "100%" }}
            />
          </div>

          <Button
            // loading={isUploading || isAgentGettingPredeterminatonData}
            loading={isUploading}
            type="primary"
            style={{ width: "100%", padding: "20px", fontSize: 18 }}
            onClick={handleSendRequest}
            disabled={files.length === 0 || title === ""}
          >
            Request
          </Button>
        </>
      )}

      {/* Eligibility Form Modal */}
      {/* <PatientPolicyInfoFormModal
        setShowPatientInsuranceFormModal={setShowPatientInsuranceFormModal}
        checkPatientInsuranceEligibility={checkPatientInsuranceEligibility}
        showPatientInsuranceFormModal={showPatientInsuranceFormModal}
        setEditPatientInsuranceData={setEditPatientInsuranceData}
        editPatientInsuranceData={editPatientInsuranceData}
        setCancelProcess={setCancelProcess}
        patientID={patient.id}
      /> */}

      {/* 2FA Form Modal */}
      {/* <Eligibility2FAFormModal
        setShowEligibility2FAFormModal={setShowEligibility2FAFormModal}
        showEligibility2FAFormModal={showEligibility2FAFormModal}
        eligibilityAgentToken={eligibilityAgentToken}
        setCancelProcess={setCancelProcess}
        type="predetermination"
      /> */}
    </Modal>
  );
}
